import type { Branch, Service } from "../data/site";

export type BookingInput = {
  branchId: string;
  serviceId: string;
  name: string;
  phone: string;
  email?: string;
  preferredDate: string;
  preferredWindow: string;
  notes: string;
  consent?: boolean;
};

export type BookingValidation =
  | { ok: true; data: BookingInput }
  | { ok: false; errors: Partial<Record<keyof BookingInput, string>> };

const phonePattern = /^[+]?[\d\s-]{9,18}$/;

export function validateBookingRequest(input: BookingInput): BookingValidation {
  const errors: Partial<Record<keyof BookingInput, string>> = {};

  if (!input.branchId) errors.branchId = "Sila pilih cawangan.";
  if (!input.serviceId) errors.serviceId = "Sila pilih servis.";
  if (!input.name.trim()) errors.name = "Sila masukkan nama pesakit.";
  if (!phonePattern.test(input.phone.trim())) errors.phone = "Sila masukkan nombor telefon yang sah.";
  if (!input.preferredDate) errors.preferredDate = "Sila pilih tarikh pilihan.";
  if (!input.preferredWindow) errors.preferredWindow = "Sila pilih masa pilihan.";
  if (!input.consent) errors.consent = "Sila setuju dengan notis privasi.";

  return Object.keys(errors).length > 0 ? { ok: false, errors } : { ok: true, data: input };
}

export function buildWhatsAppLink({ branch, message }: { branch: Branch; message: string }) {
  return `https://wa.me/${branch.whatsapp}?text=${encodeURIComponent(message)}`;
}

export function buildBookingMessage({
  branch,
  service,
  name,
  phone,
  preferredDate,
  preferredWindow,
  notes,
  email,
}: {
  branch: Branch;
  service?: Service;
  name?: string;
  phone?: string;
  email?: string;
  preferredDate?: string;
  preferredWindow?: string;
  notes?: string;
  consent?: boolean;
}) {
  const lines = [
    "Assalamualaikum Usrah Medic.",
    "Saya ingin semak slot temujanji.",
    `Cawangan: ${branch.shortName}`,
    `Servis: ${service?.title ?? "Belum pasti"}`,
  ];

  if (name) lines.push(`Nama: ${name}`);
  if (phone) lines.push(`Telefon: ${phone}`);
  if (email) lines.push(`E-mel: ${email}`);
  if (preferredDate) lines.push(`Tarikh pilihan: ${preferredDate}`);
  if (preferredWindow) lines.push(`Masa pilihan: ${preferredWindow}`);
  if (notes) lines.push(`Nota/sebab: ${notes}`);

  lines.push("Mohon bantu sahkan slot yang tersedia. Terima kasih.");
  return lines.join("\n");
}
